import { fontSmoothing, getFontFamily } from '../../typography';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    paddingTop: idsTokens.list.default.spacing.padding.default.modal.top,
    paddingRight: idsTokens.list.default.spacing.padding.default.modal.right,
    paddingBottom: idsTokens.list.default.spacing.padding.default.modal.bottom,
    paddingLeft: idsTokens.list.default.spacing.padding.default.modal.left,
    gap: idsTokens.list.default.spacing.padding.default.modal.gap,
    '&:focus-visible': {
      outline: 'unset',
    },

    // Styles for Select, Menu and other components that might have a list inside

    '& > .MuiMenuItem-root': {
      display: 'flex',
      alignItems: 'center',
      border: '2px solid rgba(0,0,0,0)',
      borderRadius: idsTokens.listItem.default.radius.standard,
      background: idsTokens.listItem.default.color.background.enabled,
      color: idsTokens.listItem.default.color.text.label.enabled,
      gap: idsTokens.listItem.default.spacing.standard.padding.gap,
      boxSizing: 'border-box',
      outline: 'none',
      minWidth: idsTokens.listItem.default.spacing.standard.min.width,
      minHeight: idsTokens.listItem.default.spacing.standard.min.height,
      paddingTop: idsTokens.listItem.default.spacing.standard.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.standard.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.standard.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.standard.padding.left,

      fontFamily: getFontFamily(idsTokens),
      ...fontSmoothing,
      fontSize: idsTokens.typography.font.size.base,
      fontStyle: 'normal',
      fontWeight: idsTokens.typography.font.weight.regular,
      letterSpacing: idsTokens.typography.spacing.letter.lg,
      lineHeight: idsTokens.typography.lineHeight.base,
    },
    '& > .MuiMenuItem-root.Mui-sizeSmall': {
      minWidth: idsTokens.listItem.default.spacing.small.min.width,
      minHeight: idsTokens.listItem.default.spacing.small.min.height,
      paddingTop: idsTokens.listItem.default.spacing.small.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.small.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.small.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.small.padding.left,
      gap: idsTokens.listItem.default.spacing.small.padding.gap,
      ...fontSmoothing,
      fontSize: idsTokens.typography.font.size.sm,
      lineHeight: idsTokens.typography.lineHeight.sm,
      letterSpacing: idsTokens.typography.spacing.letter.md,
      height: 'unset',
    },
    '& > .MuiMenuItem-root:hover': {
      color: idsTokens.listItem.default.color.text.label.hover,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.default.color.background.hover,
    },
    '& > .MuiMenuItem-root:focus-visible, & > .MuiMenuItem-root.Mui-focused, & > .MuiMenuItem-root:focus-visible:not([data-value=""])': {
      color: idsTokens.listItem.default.color.text.label.focus,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.default.color.background.focus,
      outline: 'none',
      paddingTop: idsTokens.listItem.default.spacing.standard.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.standard.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.standard.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.standard.padding.left,
      margin: 0,
    },
    '& > .MuiMenuItem-root.Mui-sizeSmall:focus-visible, & > .MuiMenuItem-root.Mui-sizeSmall.Mui-focused': {
      paddingTop: idsTokens.listItem.default.spacing.small.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.small.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.small.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.small.padding.left,
    },
    '& > .MuiMenuItem-root:active:focus': {
      background: idsTokens.listItem.default.color.background.pressed,
      color: idsTokens.listItem.default.color.text.label.pressed,
    },
    '& > .MuiMenuItem-root[disabled], & > .MuiMenuItem-root[aria-disabled="true"], & > .MuiMenuItem-root.Mui-disabled': {
      color: idsTokens.listItem.default.color.text.label.disabled,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.error.color.background.disabled,
    },

    '& > .MuiMenuItem-root.Mui-error': {
      color: idsTokens.listItem.error.color.text.label.enabled,
      minWidth: idsTokens.listItem.error.spacing.standard.min.width,
      minHeight: idsTokens.listItem.error.spacing.standard.min.height,
      paddingTop: idsTokens.listItem.error.spacing.standard.padding.top,
      paddingRight: idsTokens.listItem.error.spacing.standard.padding.right,
      paddingBottom: idsTokens.listItem.error.spacing.standard.padding.bottom,
      paddingLeft: idsTokens.listItem.error.spacing.standard.padding.left,
      gap: idsTokens.listItem.error.spacing.standard.padding.gap,

      border: '2px solid rgba(0,0,0,0)',
      borderRadius: idsTokens.listItem.error.radius.standard,
      background: idsTokens.listItem.error.color.background.enabled,
    },
    '& > .MuiMenuItem-root.Mui-error.Mui-sizeSmall': {
      minWidth: idsTokens.listItem.error.spacing.small.min.width,
      minHeight: idsTokens.listItem.error.spacing.small.min.height,
      paddingTop: idsTokens.listItem.error.spacing.small.padding.top,
      paddingRight: idsTokens.listItem.error.spacing.small.padding.right,
      paddingBottom: idsTokens.listItem.error.spacing.small.padding.bottom,
      paddingLeft: idsTokens.listItem.error.spacing.small.padding.left,
      gap: idsTokens.listItem.error.spacing.small.padding.gap,
    },
    '& > .MuiMenuItem-root.Mui-error:hover': {
      color: idsTokens.listItem.error.color.text.label.hover, // #300);
      background: idsTokens.listItem.error.color.background.hover, //#FCEBEB);
    },
    '& > .MuiMenuItem-root.Mui-error:focus, & > .MuiMenuItem-root.Mui-error.Mui-focused, & > .MuiMenuItem-root.Mui-error:focus-visible': {
      color: idsTokens.listItem.error.color.text.label.focus,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.error.color.background.focus,
      outline: 'none',
    },
    '& > .MuiMenuItem-root.Mui-error:active': {
      color: idsTokens.listItem.error.color.text.label.pressed,
      borderBottom: `0.5px solid ${idsTokens.listItem.error.color.border.pressed}`,
      background: idsTokens.listItem.error.color.background.pressed,
    },
    '& > .MuiMenuItem-root.Mui-error:active:focus': {
      color: idsTokens.listItem.error.color.text.label.pressed,
      borderBottom: `0.5px solid ${idsTokens.listItem.error.color.border.pressed}`,
      background: idsTokens.listItem.error.color.background.pressed,
      border: '2px solid rgba(0,0,0,0)',
      outline: 'none',
    },
    '& > .MuiMenuItem-root.Mui-error[disabled], & > .MuiMenuItem-root.Mui-error[aria-disabled="true"], & > .MuiMenuItem-root.Mui-error.Mui-disabled': {
      color: idsTokens.listItem.error.color.text.label.disabled,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.error.color.background.disabled,
    },
  },
});
